import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import { handleErrorToast } from "../custom";
import { Modal } from "react-bootstrap";
import { ViewChatImageorFile, formatDateTime } from "../custom";





const TicketChatboxModal = ({ i, clientemail, clientname, ticket_name, status, productname }) => {

    const chatboxRef = useRef(null);
    const [chatShow, setChatShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChatOpen = (id) => {
        getTicketChat();
        setChatShow(true);
    };

    const handleChatClose = () => {
        setChatShow(false);
    };

    const [formData, setFormData] = useState({
        ticket_name: "",
        ticket: "",
        sender: sessionStorage.getItem("email") || "",
        sender_name: sessionStorage.getItem("name") || "",
        message: "",
        image: '',
        document: null,
        timestamp: new Date().toISOString(),
        ticketaccepted_by_email: "",
        ticketaccepted_by_name: "",
        ticket_for_productname: "",
        read_status: false,

    });
    console.log("formData")
    console.log(formData)


    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            ticketaccepted_by_email: clientemail,
            ticketaccepted_by_name: clientname,
            ticket_name: ticket_name,
            ticket_for_productname: productname,
            ticket: i,
        }))
    }, [clientname, clientemail, ticket_name]);



    console.log("formData");
    console.log(formData.ticket);



    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;

        let newValue;
        console.log(value, 'newvalue')
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            if (files.length > 0) {
                newValue = files
            } else {
                newValue = null;
            }
        } else {
            newValue = value;
        }

        console.log(newValue)
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        // for removing error by clicking on input if any errors show 
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleFileChange = (e) => {
        const { name, value } = e.target;
        const file = e.target.files[0];

        if (file) {
            setFormData({ ...formData, [name]: file, });
            setFileName(file.name);
        } else {
            setFileName("");
        }

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }

    };
    const handleClear = () => {
        setFormData(prevState => ({
            ...prevState,
            document: null
        }));
        setFileName("");

    }

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [fileName, setFileName] = useState("");

    console.log(formData.files !== "")
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            formData.document !== null ? null : "message",
        ].filter(Boolean);
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        console.log("newErrors");
        console.log(newErrors);

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSendTaskRemark = async (e) => {

        if (e && e.preventDefault) {
            e.preventDefault();
        }

        console.log("formData");
        console.log(formData);

        if (validateForm()) {
            setLoading(true);
            // const loadingToastId = toast.loading("Loading: Please wait...");

            const formDataToSend = new FormData();
            Object.keys(formData).forEach((key) => {
                if (formData[key] && key !== "document") {
                    formDataToSend.append(key, formData[key]);
                }
            });

            const symbols = '!@#$%^&*()_-+=';
            const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz';
            const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            const numbers = '0123456789';
            const now = new Date();
            let date = now.toLocaleDateString('en-GB').split('/').reverse().join('-'); // Format: YYYY-MM-DD
            let time = now.toLocaleTimeString('en-GB', { hour12: false }).replace(/:/g, '-'); // Format: HH-MM-SS
            const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
            let randomCode = '';
            for (let i = 0; i < 8; i++) {
                const randomIndex = Math.floor(Math.random() * allChars.length);
                randomCode += allChars[randomIndex];
            }

            let originalFile, customFileName, customFile;
            if (formData.document) {
                originalFile = formData.document;
                customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
                customFile = new File([originalFile], customFileName, { type: originalFile.type });
                formDataToSend.append("document", customFile);
            }

            try {
                let res = await axios.post(`${BASE_URL}/ticket/ticketChat/`, formDataToSend, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                if (res.status === 200) {
                    await getTicketChat();
                    setFormData({
                        ...formData,
                        message: "",
                        files: '',
                    });
                    handleClear();
                } else {
                    alert(res);
                }
            } catch (err) {
                // handleErrorToast(err, loadingToastId);
                handleErrorToast(err);
            } finally {
                setLoading(false);
                // toast.dismiss(loadingToastId);
            }
        }
    };
    // const handleSendTaskRemark = async (e) => {
    //     e.preventDefault();

    //     console.log("formData");
    //     console.log(formData);

    //     if (validateForm()) {
    //         setLoading(true);
    //         const loadingToastId = toast.loading("Loading: Please wait...");


    //         const formDataToSend = new FormData();
    //         Object.keys(formData).forEach((key) => {
    //             if (formData[key] && key !== "document") {
    //                 formDataToSend.append(key, formData[key]);
    //             }
    //         });

    //         const symbols = '!@#$%^&*()_-+=';
    //         const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz';
    //         const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    //         const numbers = '0123456789';
    //         const now = new Date();
    //         let date = now.toLocaleDateString('en-GB').split('/').reverse().join('-'); // Format: YYYY-MM-DD
    //         let time = now.toLocaleTimeString('en-GB', { hour12: false }).replace(/:/g, '-'); // Format: HH-MM-SS
    //         const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
    //         let randomCode = '';
    //         for (let i = 0; i < 8; i++) {
    //             const randomIndex = Math.floor(Math.random() * allChars.length);
    //             randomCode += allChars[randomIndex];
    //         }
    //         let originalFile
    //         let customFileName
    //         let customFile
    //         if (formData.document) {
    //             originalFile = formData.document;
    //             customFileName = Aimantra ${date} ${time}_${randomCode} ${originalFile.name};
    //             customFile = new File([originalFile], customFileName, { type: originalFile.type });
    //             formDataToSend.append("document", customFile);
    //         }


    //         try {
    //             let res = await axios.post(${BASE_URL}/ticket/ticketChat/, formDataToSend, {
    //                 headers: {
    //                     "Content-Type": "multipart/form-data",
    //                 },
    //             });

    //             if (res.status === 200) {
    //                 await getTicketChat();
    //                 setFormData({
    //                     ...formData,
    //                     message: "",
    //                     files: '',
    //                 });

    //                 // setChatShow(false);
    //                 // refreshData();
    //             } else {
    //                 alert(res);
    //             }
    //         } catch (err) {
    //             // alert(err);
    //             handleErrorToast(err, loadingToastId);
    //         } finally {
    //             setLoading(false);
    //             toast.dismiss(loadingToastId);
    //         }
    //     }
    // };

    // !########################################################################

    const [ticketChat, setTicketChat] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic
    const getFileNameFromLink = (url) => {
        try {
            const ImgFileUrl = "https://cipl-aimantra.s3.amazonaws.com/" || "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
            // const ImgFileUrl = "https://cipl-aimantra.s3.amazonaws.com/" || "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";

            if (url.startsWith(ImgFileUrl)) {
                const pathAfterBase = url.slice(ImgFileUrl.length);

                const fileName = pathAfterBase.split('/').slice(1).join('/').split('?')[0];

                return fileName;
            }

            return url;
        } catch (error) {
            console.error("Error extracting file name:", error);
            return "";
        }
    };
    const getTicketChat = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/ticket/ticketChat-by-ticket/${i}/`
            );
            setTicketChat(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        // Scroll to the bottom whenever new messages arrive
        if (chatboxRef.current) {
            chatboxRef.current.scrollTop = chatboxRef.current.scrollHeight;
        }
    }, [ticketChat]); // Runs whenever ticketChat updates

    return (
        <>
            <button onClick={() => handleChatOpen(i)}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 64 64"
                    id="chat-box"
                    fill="none"
                >
                    <path
                        fill="#2576BC"
                        d="M40,54.78a3,3,0,0,1-1.89-.68l-7.73-6.33a1,1,0,1,1,1.26-1.54l7.74,6.32A1,1,0,0,0,41,51.78V47a1,1,0,0,1,1-1,5.07,5.07,0,0,0,5-5V25a4.94,4.94,0,0,0-4.86-5H10.86A4.94,4.94,0,0,0,6,25V41a4.94,4.94,0,0,0,4.86,5H25.52a1,1,0,0,1,0,2H10.86A6.94,6.94,0,0,1,4,41V25a6.94,6.94,0,0,1,6.86-7H42.14A6.94,6.94,0,0,1,49,25V41a7,7,0,0,1-6,6.93v3.85a3,3,0,0,1-1.72,2.71A2.93,2.93,0,0,1,40,54.78ZM53.14,38a1,1,0,0,1,0-2A4.94,4.94,0,0,0,58,31V15a4.94,4.94,0,0,0-4.86-5H21.87a4.88,4.88,0,0,0-4.8,4.16,1,1,0,1,1-2-.32A6.88,6.88,0,0,1,21.87,8H53.14A6.94,6.94,0,0,1,60,15V31A6.94,6.94,0,0,1,53.14,38ZM37,35a2,2,0,1,1,2-2A2,2,0,0,1,37,35ZM26,35a2,2,0,1,1,2-2A2,2,0,0,1,26,35ZM15,35a2,2,0,1,1,2-2A2,2,0,0,1,15,35Z"
                    ></path>
                </svg>
            </button>

            <Modal
                show={chatShow}
                onHide={handleChatClose}
                dialogClassName="request-leave "
            >
                <Modal.Header closeButton>
                    <Modal.Title>Ticket Chat History</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="flex-column ">
                        <ul className="chatbox" ref={chatboxRef} style={{ overflowY: "auto", maxHeight: "500px" }}>
                            {buffer ? <div className="spinner-z"></div> : null}
                            {ticketChat.length === 0 ? (
                                <div className="align-center justify-center" style={{ alignSelf: "center" }}>
                                    - No Chat Historys 🪹 -
                                </div>
                            ) : (
                                ticketChat
                                    .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
                                    .map((i, index) => (
                                        <div key={index}>
                                            {i.sender === sessionStorage.getItem("email") ? (
                                                <>
                                                    <p className="chat-reply-timestamp font-size-text chat-reply">{i.sender_name}</p>
                                                    <div className="chat chat-reply" style={{ padding: "10px" }}>
                                                        <li className="p-li">
                                                            {i.message ? <p>{i.message}</p> : <ViewChatImageorFile textcss="chat-photo-reply" filesrc={i.document} />}
                                                        </li>
                                                        <p className="chat-reply-timestamp pad-r text-right font-size-label">
                                                            {formatDateTime(i.timestamp).full}
                                                        </p>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <p className="chat-incoming-timestamp font-size-text">{i.sender_name}</p>
                                                    <div className="chat chat-incoming">
                                                        <li className="p-li">
                                                            {i.message ? <p>{i.message}</p> : <ViewChatImageorFile textcss="chat-photo-incoming" filesrc={i.document} />}
                                                        </li>
                                                        <p className="chat-incoming-timestamp pad-r text-right font-size-label">
                                                            {formatDateTime(i.timestamp).full}
                                                        </p>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    ))
                            )}
                        </ul>
                        {/* <ul className="chatbox">
                            {buffer ? (
                                <div className="spinner-z"></div>
                            ):null}
                            {ticketChat.length === 0 ? (
                                <div
                                    className="align-center justify-center "
                                    style={{ alignSelf: "center" }}
                                >
                                    - No Chat Historys 🪹 -
                                </div>
                            ) : (
                                <>
                                    {ticketChat
                                        .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
                                        .map((i, index) => (
                                            <>
                                                {i.sender == sessionStorage.getItem("email") ? (
                                                    <>
                                                        <p className="chat-reply-timestamp font-size-text">
                                                            {i.sender_name}
                                                        </p>

                                                        <div className="chat chat-reply">
                                                            <li className="p-li">
                                                                {i.message ? (
                                                                    <>
                                                                        <p>{i.message}</p>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <ViewChatImageorFile
                                                                            textcss={'chat-photo-reply'}
                                                                            filesrc={i.document}
                                                                        />
                                                                    </>
                                                                )}

                                                            </li>
                                                            <p className="chat-reply-timestamp pad-r text-right font-size-label">
                                                                {formatDateTime(i.timestamp).full}
                                                            </p>
                                                        </div>

                                                    </>
                                                ) : (
                                                    <>
                                                        <p className="chat-incoming-timestamp font-size-text ">
                                                            {i.sender_name}
                                                        </p>

                                                        <div className="chat chat-incoming">
                                                            <li className="p-li">
                                                                {i.message ? (
                                                                    <>
                                                                        <p>{i.message}</p>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <ViewChatImageorFile
                                                                            textcss={'chat-photo-incoming'}
                                                                            filesrc={i.document}
                                                                        />
                                                                    </>
                                                                )}


                                                            </li>
                                                            <p className="chat-incoming-timestamp pad-r text-right font-size-label">
                                                                {formatDateTime(i.timestamp).full}
                                                            </p>
                                                        </div>


                                                    </>
                                                )}
                                            </>
                                        ))}
                                </>

                            )}
                        </ul> */}
                        {status !== "completed" ?
                            <div>
                                <div className="flex-row justify-betweeen chat-input"
                                    style={{ height: "43px", display: "flex", justifyContent: "space-between" }}
                                >

                                    {formData.document ?
                                        <>
                                            <div className="chat-input-textarea">
                                                {fileName && <p style={{ margin: "0px" }}>{fileName}</p>}
                                            </div>
                                            <button className="chat-clear" onClick={handleClear}>Clear</button>
                                        </>
                                        :

                                        <textarea
                                            id="message"
                                            name="message"
                                            maxLength={500}
                                            placeholder="Enter Message"
                                            onChange={handleInputChange}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" && !e.shiftKey) {
                                                    e.preventDefault();
                                                    handleSendTaskRemark();
                                                }
                                            }}
                                            value={formData.message}
                                            style={{ height: "20px", minHeight: "22px", resize: "vertical", borderBlock: "none", border: "none" }}
                                            className={`textarea-custom ${errors.message ? "textarea-error" : inputState.message ? "textarea-success" : ""}`}
                                        />




                                    }

                                    {formData.document && (
                                        <div>
                                            <span>{formData.document.fileName}</span>


                                            {formData.document.previewUrl && (
                                                <img src={formData.document.previewUrl} alt="File Preview" width={100} />
                                            )}
                                        </div>
                                    )}

                                    <div className="btn-cont align-end gap-const">

                                        <label htmlFor="document" >
                                            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20 7V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12.5M18 18V12.5C18 11.6716 18.6716 11 19.5 11C20.3284 11 21 11.6716 21 12.5V18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18V14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            <input
                                                id="document"
                                                name="document"
                                                type="file"
                                                accept=".pdf, .doc, .docx, .png, .jpeg, .jpg"
                                                onChange={handleFileChange}
                                                onFocus={handleClear}
                                                style={{ display: "none", position: "relative" }}

                                                className={`  ${errors.document ? "error" : inputState.document ? "success" : ""
                                                    }`}
                                            />
                                        </label>




                                        <button onClick={handleSendTaskRemark} disabled={loading}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                enable-background="new 0 0 32 32"
                                                viewBox="0 0 32 32"
                                                id="send"
                                                width="30"
                                                height="30"
                                            >
                                                <path
                                                    fill="#2576BC"
                                                    d="M30.5,14.58997l-28-10c-0.54999-0.19995-1.16998-0.04999-1.58002,0.37C0.51001,5.38,0.39001,6.01001,0.60999,6.56l2.91882,7.31079C3.68054,14.25073,4.0484,14.5,4.45752,14.5h7.70245c0.83002,0,1.5,0.66998,1.5,1.5c0,0.82996-0.66998,1.5-1.5,1.5H4.45752c-0.40912,0-0.77698,0.24921-0.92871,0.62921L0.60999,25.44c-0.21997,0.54999-0.09998,1.17999,0.31,1.59998C1.21002,27.33997,1.59998,27.5,2,27.5c0.16998,0,0.34003-0.03003,0.5-0.09003l28-10c0.59998-0.20996,1-0.77997,1-1.40997S31.09998,14.79999,30.5,14.58997z"
                                                ></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div> :
                            <p className="text-center">
                                "Task Completed"
                            </p>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {errors.message && (
                        <span className="error-message font-size-text ">
                            {errors.message}
                        </span>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    );
};


export { TicketChatboxModal }